import type { FormValues } from "../templates/serp/Serp";

// TODO
// There's an implicit expectation this is only called on submit.
// In DC9 it's called on render to get the next path, but

export default function getNavigatePath(data: FormValues, nextPath: string) {
  // strip out PII values and non-user-facing values...
  const {
    email,
    firstname,
    lastname,
    phone,

    compare,
    coRegPartner,
    ...dataWithoutPII
  } = data;

  if (nextPath.startsWith("https")) {
    // TODO - This is really only for external urls. We should use a different helper.
    return nextPath
      .replace(/{{keyword}}/g, dataWithoutPII.position)
      .replace(/{{location}}/g, dataWithoutPII.location || "")
      .replace(/{{zip}}/g, dataWithoutPII.postCode || "")
      .replace(/{{email}}/g, email || "")
      .replace(/{{firstname}}/g, firstname || "")
      .replace(/{{lastname}}/g, lastname || "")
      .replace(/{{phone}}/g, phone || "")
      .replace(/{{postCode}}/g, dataWithoutPII.postCode || "")
      .replace(/{{glcid}}/g, dataWithoutPII.gclid || "")
      .replace(/{{utmCampaign}}/g, dataWithoutPII.utm_campaign || "")
      .replace(/{{utmContent}}/g, dataWithoutPII.utm_content || "")
      .replace(/{{utmMedium}}/g, dataWithoutPII.utm_medium || "")
      .replace(/{{utmSource}}/g, dataWithoutPII.utm_source || "")
      .replace(/{{utmTerm}}/g, dataWithoutPII.utm_term || "");
  }

  // ... convert PII-less data to querystring
  const qs = new URLSearchParams(dataWithoutPII);
  return `${nextPath}?${qs}`;
}
